import React from "react";
import { Consent } from "../../../shared/Cookiebot";
import { cookiesRequiredForCategory } from "../../../shared/helpers";
import { ToggleEventHandler }
  from "../../../../Common/components/BancoToggleSwitch/BancoToggleSwitch";
import { ConsentToggle } from "./ConsentToggle";
import styles from "../styles/styles.module.scss";

export type ConsentControlsProps = {
  userSelection: Consent,
  setUserSelection: React.Dispatch<React.SetStateAction<Consent>>
}

export const ConsentControls = ({ userSelection, setUserSelection }:
  ConsentControlsProps) => {
  const handleToggle: ToggleEventHandler = (isSelected, _, id) => {
    setUserSelection({
      ...userSelection,
      [id]: isSelected
    });
  };

  return (
    <>
      <ConsentToggle
        heading={ "Essential cookies (required)" }
        body={ "Used so the website functions properly for you." }
      />
      { cookiesRequiredForCategory("marketing") &&
        (
          <>
            <hr className={ styles.hr } />
            <ConsentToggle
              heading={ "Marketing cookies" }
              body={ "Help target online adverts and measure how they perform." }
              toggleConfig={ {
                id: "marketing",
                checked: userSelection.marketing,
                handleToggle
              } }
            />
          </>
        )
      }
    </>
  );
};
